module.exports = __webpack_public_path__ + "img/show-content-title.8fd1fc52.png";